import type { WorkbenchCardType, WorkbenchContent } from "./contentSchemas";

export function canSelectAdvertisingAccount(cardType: WorkbenchCardType, errorCode?: string) {
  return (cardType === "advertising_management" || cardType === "advertising_performance")
    && !["shop_binding_required", "shop_binding_unavailable", "shop_reauthorization_required", "adaccounts_read_required"].includes(errorCode ?? "");
}

const reasonTitles: Record<string, string> = {
  ad_account_binding_required: "请先绑定广告账户",
  ad_account_selection_required: "请选择广告账户",
  ad_account_selection_unavailable: "所选广告账户不可用",
  adaccounts_read_required: "当前成员没有广告账户读取权限",
  shop_binding_required: "请先绑定店铺",
  shop_binding_unavailable: "当前店铺连接不可用",
  shop_reauthorization_required: "当前店铺需要重新授权",
  shop_selection_required: "请选择当前店铺",
  source_sync_required: "当前范围尚无安全数据快照",
  source_sync_disabled: "当前模块的自动同步已关闭",
  source_sync_not_configured: "当前模块尚未配置自动同步",
  source_sync_provider_authorization_failed: "来源授权失败",
  source_sync_provider_contract_invalid: "来源数据格式异常",
  source_sync_provider_unavailable: "来源暂不可用",
  source_sync_failed: "来源同步失败",
  provider_family_unsupported: "当前平台暂不支持此模块",
};

const fallbackTitles: Record<WorkbenchContent["state"], string> = {
  ready: "",
  requires_binding: "当前连接需要处理",
  requires_setup: "先完成所需设置",
  empty: "暂时没有相关资料",
  unavailable: "当前来源暂不可用",
  error: "资料读取失败",
};

export function workbenchStateTitle(state: WorkbenchContent["state"], errorCode: string) {
  if (state === "ready") return "";
  return reasonTitles[errorCode] ?? fallbackTitles[state];
}
